import React, { useState, useEffect } from 'react';
import '../housestyle.css';
import './Staff.css';
import api from '../API/Api';
import PageHero from '../components/PageHero';

const order_roles = [
  'Owner',
  'Manager',
  'H Developer',
  'Admin',
  'Developer',
  'Discord Developer',
  'H Mod',
  'SR Mod',
  'Mod',
  'JR Mod',
  'Trial Mod',
  'Helper',
  'Builder',
  'Partner Support',
  'Partner Manager',
];

const video = 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/background_vids/vid_4.mp4';


const role_color = {
  Owner: '#e84c3d',
  Manager: '#f0ab20',
  'H Developer': '#055a00',
  Admin: '#e84c3d',
  Developer: '#aa3b3b',
  'Discord Developer': '#061bb4',
  'H Mod': '#a070e0',
  'SR Mod': '#a070e0',
  Mod: '#d28305',
  'JR Mod': '#f2a11f',
  'Trial Mod': '#f2a11f',
  Helper: '#369876',
  Builder: '#bc0707',
  'Partner Support': '#52c078',
  'Partner Manager': '#7a0027',
};

function StaffCard({ member, index }) {
  const color = role_color[member.role] ?? 'var(--teal)';

  return (
    <div
      className="staff-card fade-up"
      style={{ animationDelay: `${index * 0.06}s`, '--role-color': color }}
    >
      <div className="staff-card-bigrole" aria-hidden="true">{member.role}</div>
      <div className="staff-card-top">
        <div className="staff-avatar-wrap">
          <img
            src={`https://mc-heads.net/avatar/${member.username}/80`}
            alt={member.name}
            className="staff-avatar"
          />
          <div className="staff-avatar-glow" />
        </div>
        <div className="staff-info">
          <span className="staff-role">{member.role}</span>
          <div className="staff-name">{member.name}</div>
        </div>
      </div>

      {member.quote && (
        <div className="staff-quote">"{member.quote}"</div>
      )}

      <div className="staff-meta">
        <div className="staff-meta-item">
          <span className="staff-meta-label">IGN</span>
          <span className="staff-meta-value">{member.username}</span>
        </div>
        <div className="staff-meta-item">
          <span className="staff-meta-label">Discord</span>
          <span className="staff-meta-value">{member.discord}</span>
        </div>
        <div className="staff-meta-item">
          <span className="staff-meta-label">Staff since</span>
          <span className="staff-meta-value">{member.joined_since}</span>
        </div>
      </div>
    </div>
  );
}

export default function StaffPage() {
  const [activeRole, setActiveRole] = useState('All');
  const [staffMembers, setStaffMembers] = useState([]);

  useEffect(() => {
    api('getstaff').then(res => {
      if (res.isSuccess) setStaffMembers(res.data?.staff ?? []);
    });
  }, []);

  const roles = ['All', ...order_roles.filter(r => staffMembers.some(s => s.role === r))];

  const sortedroles = [...staffMembers].sort(
    (a, b) => order_roles.indexOf(a.role) - order_roles.indexOf(b.role)
  );

  const filtered = activeRole === 'All'
    ? sortedroles
    : sortedroles.filter(s => s.role === activeRole);

  return (
    <>
      <PageHero eyebrow="The Team" title="Meet the " em="Staff" subtitle="The people keeping SimpleMC running. Want to be part of our team?" video={video} />

      <div className="container section">
        <div className="staff-toolbar">
          <div className="staff-filters">
            {roles.map(r => (
              <button
                key={r}
                onClick={() => setActiveRole(r)}
                className={`staff-filter-chip${activeRole === r ? ' active' : ''}`}
                style={{ '--fc': role_color[r] ?? 'var(--teal-bright)' }}
              >
                {r}
              </button>
            ))}
          </div>
          <div className="staff-count">
            {filtered.length} staff member{filtered.length !== 1 ? 's' : ''}
          </div>
        </div>

        <div className="grid-auto staff-grid">
          {filtered.map((m, i) => (
            <StaffCard key={m.username} member={m} index={i} />
          ))}
        </div>
      </div>
    </>
  );
}